<template>
  <div class="buyer-in-closed-page">
    <div class="buyer-in-closed-page-top">
      <BuyerSectionItem
      :icon="this.icon"
      :title="this.title"
      :description="this.description"
      :shouldReturnToTheBuyerPage="true"
    />
    </div>

    <div class="buyer-in-closed-page-content">
      <FilterSidebarInClosedItems :isMobile="true" />
    </div>
  </div>
</template>

<script>
import BuyerSectionItem from "@/views/buyer/components/BuyerSectionItem";
import FilterSidebarInClosedItems from "@/views/buyer/components/FilterSidebar/components/FilterSidebarInClosedItems";
import { BUYER_SECTION_CLOSED } from "@/views/buyer/constants/BuyerSections";
import { mapMutations } from "vuex";
import { BUYER } from "@/constants/Buyer";

export default {
  name: "BuyerClosedPage",
  components: { BuyerSectionItem, FilterSidebarInClosedItems },
  data: function () {
    return {
      ...BUYER_SECTION_CLOSED,
    };
  },
  methods: {
    ...mapMutations("buyer", [
        "setTitleSectionPage",
        "setTitlePage",
        "setSubTitlePage"
    ]),
  },
  mounted() {
    this.setTitleSectionPage(BUYER.TITLE_DASHBOARD);
    this.setTitlePage("Encerrados");
    this.setSubTitlePage("");
  },
};
</script>

<style scoped>
.buyer-in-closed-page {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.buyer-in-closed-page-top {
  width: 100%;
}

.buyer-in-closed-page-content {
  margin-top: 4px;
  background-color: white;
}
</style>
